import type { ViewState } from '#components/Root/viewModel'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomTaxOfficeInput')

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomTaxOfficeInput = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      {/* @ts-expect-error@2322 */}
      <IForm
        className={styles.form}
        onChange={viewModel.handleFormChange}
        // @ts-expect-error@2339
        onValid={viewModel.handleFormValid}
      >
        {/* @ts-expect-error@2322 */}
        <TextField label={tp('tax-office')} optional property='taxOffice' />
      </IForm>
    </StepContent>
    <BottomActions
      // @ts-expect-error@2339
      extraButtons={viewModel.buttons}
      // @ts-expect-error@2339
      nextEnabled={viewModel.isValid}
      onBack={viewModel.handleBack}
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomTaxOfficeInput)
component.displayName = 'CustomTaxOfficeInput'
export default component
